// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__cq6YG","column":"style_column__2irLT","row":"style_row__1zZoN"};